import { atom } from 'jotai';

export const uploadMapDataPanelOpenAtom = atom<boolean>(false);
